import { SectionProps } from '../types';
import { StyledBagelCodeSection } from './style';

export const BagelCodeSection = ({ sectionName, image }: SectionProps) => {
    const bgImage =
        'https://media.appcharge.com/media/65a7981a2d887f00c2fda251/bagelcode-section.png';
    return (
        <StyledBagelCodeSection className={'section-bagelcode'}>
            <img
                className="section-bagelcode__bg-img"
                src={bgImage}
                alt={'bg-img'}
            />
            <div className={'section-bagelcode__content'}>
                {image && (
                    <img
                        className={'section-bagelcode__prefix-image'}
                        src={image}
                        alt={sectionName + `prefix image`}
                    />
                )}
                <span className={'section-bagelcode__section-name'}>
                    {sectionName}
                </span>
            </div>
        </StyledBagelCodeSection>
    );
};

export default BagelCodeSection;
